<template>
  <div class="flex flex-col items-start w-full">
    <div
      class="sticky top-0 bg-TERTIARY z-10 flex flex-row items-center justify-between  w-full px-4 relative"
      :class="isScrolled ? 'py-5 border-b border-GREY' : 'py-2.5'"
    >
      <div class="flex flex-row gap-2 items-center">
        <button @click="$router.back()">
          <font-awesome-icon icon="fa-solid fa-arrow-left" />
        </button>
        <p class="text-sm text-white font-semibold">Store</p>
      </div>

      <div
        class="absolute  inset-0 m-auto w-[40px] h-[40px] bg-LIGHTGREY rounded-md flex justify-center items-center"
        v-if="isScrolled"
      >
        <img src="@/assets/images/empty-img.svg" class="w-4 h-5  object-contain" />
      </div>
    </div>
    <div class="flex flex-col items-start w-full px-4">
      <div
        class="h-[340px] relative bg-LIGHTBLUE flex flex-col items-center justify-center rounded-md w-full"
      >
        <div
          class="flex absolute right-2 top-2 h-[32px] w-[32px] items-center justify-center bg-WHITE rounded-xl p-2.5"
        >
          <font-awesome-icon class="black-icon" icon="fa-regular fa-bookmark" />
        </div>

        <img src="@/assets/images/empty-img.svg" class="w-6 h-7 object-contain" />

        <div class="absolute left-2 bottom-2 rounded-md bg-LIGHTGREY py-0.5 px-1 border border-1">
          <p class="text-PRIMARY text-xs min-w-6 font-semibold">SSR</p>
        </div>
      </div>

      <div class="flex flex-col gap-1 items-start mt-5">
        <div class="tet-sm font-semibold">Ghozali_Ghozalu #631</div>
        <div class="flex flex-row gap-2 items-center">
          <font-awesome-icon class="" icon="fa-regular fa-user" />
          <p class="text-GREY text-xs">Created by</p>
          <p class="text-xs">Oğuzhan Yıldız</p>
        </div>
      </div>
      <div
        class="rounded-lg bg-[#061527] flex flex-row justify-between items-center p-2 my-5 w-full"
      >
        <div class="flex flex-col justify-center items-center min-w-[80px]">
          <font-awesome-icon class="arrow_icon_color" icon="fa-regular fa-eye" />
          <p class="text-xs font-medium mt-2">122K</p>
          <p class="text-GREY text-[10px] mt-0.5">Views</p>
        </div>
        <div class="border-l h-[60px] border-1 border-GREY rounded-full"></div>

        <div class="flex flex-col justify-center items-center min-w-[80px]">
          <font-awesome-icon class="arrow_icon_color" icon="fa-regular fa-bookmark" />
          <p class="text-xs font-medium mt-2">195</p>
          <p class="text-GREY text-[10px] mt-0.5">Favorite</p>
        </div>
        <div class="border-l h-[60px] border-1 border-GREY rounded-full"></div>
        <div class="flex flex-col justify-center items-center min-w-[80px]">
          <font-awesome-icon class="arrow_icon_color" icon="fa-regular fa-user" />
          <p class="text-xs font-medium mt-2">1</p>
          <p class="text-GREY text-[10px] mt-0.5">Owners</p>
        </div>
      </div>
      <p class="text-sm font-semibold text-start mb-3">Description</p>
      <p class="text-GREY text-sm text-start">
        Lorem ipsum dolor sit amet consectetur. A arcu amet non diam eget nulla id. Ac morbi turpis.
        <br />
        Lorem ipsum dolor sit amet consectetur. Arcu ultricies mus sed odio sit vitae elementum
        donec sit. Ac mi tortor morbi sed. Elit aliquam porta consequat lacus dui ut. Gravida quam
        ultricies nibh lectus donec vulputate ornare viverra. A pulvinar.
      </p>
      <div class="border-t border-0.5 border-GREY rounded-full my-5 w-full"></div>
      <p class="text-sm font-semibold text-start mb-3">Other from this Collection</p>
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 md:grid-cols-5 gap-4 w-full">
        <nft-card
          @click="router.push({ name: 'NftDetailPage' })"
          v-for="nft in tempNftData"
          :nft-data="nft"
        >
          <div :class="nft.state == 'owned'" class="gap-2.5 flex flex-col items-start min-h-[60px]">
            <p class="font-semibold text-sm">{{ nft.name }}</p>
            <div
              v-if="nft.state == 'sale'"
              class="flex flex-row gap-2 justify-center w-full items-center"
            >
              <pow-button size="xs" tertiary class="w-full">
                <div class="flex flex-row gap-0.5 items-center">
                  <p class="text-xs">Buy for (</p>
                  <img src="@/assets/icons/token-2.svg" class="h-3 object-contain" />
                  <p class="text-xs">150 )</p>
                </div>
              </pow-button>
            </div>
            <p v-else-if="nft.state == 'owned'" class="text-xs">Owned</p>
            <div v-else-if="nft.state == 'bought'" class="flex flex-col gap-1 items-start">
              <p class="text-xs text-GREY">Owned by</p>
              <p class="text-xs text-GREY underline">walletmarhennan</p>
            </div>
          </div>
        </nft-card>
      </div>
    </div>

    <div class="sticky bottom-0 w-full p-4 bg-TERTIARY border-t border-1 border-GREY mt-4">
      <pow-button @click="openSuccesDrawer" secondary class="w-full">
        <div class="flex flex-row gap-1 items-center justify-center">
          <p class="text-xs">Buy NFT</p>
          <img src="@/assets/icons/token-2.svg" class="h-3 object-contain" />
          <p class="text-xs">150</p>
        </div>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onUnmounted, onMounted } from 'vue'
import NftCard from '../NftCard.vue'
import PowButton from '../PowButton.vue'
import { useRouter } from 'vue-router'
import { openBottomDrawer, sizeClass } from '@/composables/bottomdrawer';
import NftBuySuccesDrawer from '../drawers/NftBuySuccesDrawer.vue';

const router = useRouter()

const openSuccesDrawer = () => {
  openBottomDrawer(NftBuySuccesDrawer, {
    props: {},
    emits: {},
    size: 'md'
  })
}

const tempNftData = ref([
  {
    name: 'Factura by Ahmet',
    type: 'SSR',
    price: '100',
    stock: '100',
    state: 'sale'
  },
  {
    name: 'Aloha by Oğuz',
    type: 'R',
    price: '300',
    stock: '210',
    state: 'bought'
  },
  {
    name: 'Vice Captain',
    type: 'SR',
    price: '150',
    stock: '50',
    state: 'owned'
  }
])

const isScrolled = ref(false)
const stickyPoint = 350 

const handleScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  isScrolled.value = scrollTop > stickyPoint
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})


</script>

<style></style>
